import React from 'react';

import type { EmailAddressProps } from './EmailAddress.types';

/**
 * An account's address inside an auth card's copy, a step brighter than the
 * words around it, and free to break anywhere: an address has no spaces to
 * wrap at.
 */
export function EmailAddress({
  email,
  fallback,
}: EmailAddressProps): React.JSX.Element {
  if (!email) return <>{fallback}</>;
  return (
    <span className="break-words font-medium text-neutral-200">{email}</span>
  );
}

export default EmailAddress;
